export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7632.8f3b9c0b.jpg";